"use client";

import { useMemo } from "react";
import DOMPurify from "dompurify";

export default function SafeHTML({ html, className = "", style = {} }) {
  const sanitizedHTML = useMemo(() => {
    if (typeof window !== "undefined") {
      return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
          "p",
          "br",
          "strong",
          "em",
          "u",
          "s",
          "b",
          "i",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "ul",
          "ol",
          "li",
          "a",
          "img",
          "blockquote",
          "pre",
          "code",
          "table",
          "thead",
          "tbody",
          "tr",
          "th",
          "td",
          "div",
          "span",
        ],
        ALLOWED_ATTR: [
          "href",
          "target",
          "rel",
          "src",
          "alt",
          "title",
          "class",
          "style",
          "width",
          "height",
        ],
        ALLOW_DATA_ATTR: false,
      });
    }
    return html;
  }, [html]);

  return (
    <div
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
}
